import { Button } from "@babackapp/ui/components/button";
import { Input } from "@babackapp/ui/components/input";
import { BACKFILL_STATUSES } from "./pii-backfill-summary";

export const ALL_STATUSES = "all";

export type BackfillFilters = { search: string; status: string };

export function PiiBackfillFilters({
  filters,
  onChange,
  visibleCount,
  selectedCount,
  onSelectVisible,
  onClearSelection,
}: {
  filters: BackfillFilters;
  onChange: (filters: BackfillFilters) => void;
  visibleCount: number;
  selectedCount: number;
  onSelectVisible: () => void;
  onClearSelection: () => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Input
        placeholder="Rechercher un shop"
        value={filters.search}
        onChange={(event) =>
          onChange({ ...filters, search: event.target.value })
        }
        className="h-8 w-56"
      />
      <select
        value={filters.status}
        onChange={(event) =>
          onChange({ ...filters, status: event.target.value })
        }
        className="h-8 rounded-md border bg-background px-2 text-sm"
      >
        <option value={ALL_STATUSES}>Tous les statuts</option>
        {Object.entries(BACKFILL_STATUSES).map(([status, label]) => (
          <option key={status} value={status}>
            {label}
          </option>
        ))}
      </select>
      <Button size="sm" variant="outline" onClick={onSelectVisible}>
        Sélectionner les {visibleCount} affichés
      </Button>
      <Button
        size="sm"
        variant="ghost"
        disabled={selectedCount === 0}
        onClick={onClearSelection}
      >
        Vider la sélection
      </Button>
    </div>
  );
}
